import React, { useState } from 'react';
import { Button } from '@mui/material';
import { FileDownload as ExportIcon } from '@mui/icons-material';
import { ScheduleExportDialogContent } from './ScheduleExportDialogContent';

interface ScheduleExportButtonProps {
  sx?: any;
}

const ScheduleExportButton: React.FC<ScheduleExportButtonProps> = ({ sx }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<ExportIcon />}
        onClick={() => setDialogOpen(true)}
        sx={sx}
      >
        Export Schedule
      </Button>

      <ScheduleExportDialogContent
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
    </>
  );
};

export default ScheduleExportButton;
